module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="l-panelContainer__panel">\r\n  <div class="l-panelContainer__content">\r\n    <div class="phx-portlet-header ">    \r\n      <span class="phx-porlet-title"></span>\r\n    </div>\r\n    <div class="phx-portlet-div">\r\n      <div class="phx-portlet-content">Lorem ipsum dolor sit amet, consectetuer adipiscing elit</div>\r\n    </div>\r\n  </div>\r\n</div>';
}
return __p;
};
